import { diag, DiagConsoleLogger, DiagLogLevel } from "@opentelemetry/api";
import { initServiceMeterProvider } from './instrument';
import { initWebVitalsMonitoring } from './web-vitals';
if (process.env.NODE_ENV === 'development') {
    diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.DEBUG);
}
try {
    initServiceMeterProvider({
        serviceName: _WEB_VITALS_SERVICE_NAME_,
        deploymentEnvironment: _WEB_VITALS_DEPLOYMENT_ENVIRONMENT_,
    });
    initWebVitalsMonitoring();
}
catch (error) {
    console.error(error);
}
